<template lang="pug">
    section#metodologia
        div.wrapper
            div.conteudo
                h2
                    |Metodologia
                p
                    |A UniFAEL utiliza uma metodologia inovadora para atender todas as necessidades
                    |do aluno no processo de ensino. No Portal Educacional, o estudante tem todas as ferramentas necessárias para
                    |concluir o Curso EAD da sua escolha com excelência e satisfação, sem precisar ir até uma sala de aula física.
                    |Para isso, se utiliza dos seguintes materiais e tecnologias:
                p
                    strong Material Didático:
                    |Disponível para acesso online, livro ou artigo científico, videoaulas e/ou entrevistas e/ou
                    |palestras produzidos para cada Disciplina, além de outros materiais complementares como slides, links e cases.
                p
                    strong Sistema de Avaliação:
                    |Realização de Provas Objetivas no Ambiente Virtual de Aprendizagem.
                p
                    strong Interatividade:
                    |Todo o curso 100% online, apoio de professores no módulo de pesquisa (TCC) e canais de atendimento para esclarecimento
                    |de dúvidas operacionais e outras informações.
                p
                    strong Certificado:
                    |A entrega da certificação poderá compreender 90 dias após a conclusão de todas as atividades das Disciplinas e condicionada
                    |a entrega de toda a documentação exigida por parte do aluno.
</template>

<script>
export default {
    name: "section-metodologia"
}
</script>

<style lang="stylus" scoped src="./Metodologia.styl"></style>
